import type React from "react";

interface QuestionCardProps {
  content: {
    question: string;
    answer: string;
  };
  index: number;
}

export const QuestionCard: React.FC<QuestionCardProps> = ({ content, index }) => {
  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-col items-start gap-2">
        <p className="font-bold text-base -tracking-[.01em] text-black">
          Q{index}. {content.question}
        </p>
        <p className="font-medium text-sm -tracking-[.01em] text-gray">A. {content.answer}</p>
      </div>
    </div>
  );
};
